var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-avatar",class:{
        'vrm-avatar--initials': !_vm.imageReady,
        'vrm-avatar--admin': _vm.hasFullControl,
        'vrm-avatar--technician': _vm.isTechnician,
    }},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageReady),expression:"imageReady"}],attrs:{"src":_vm.avatarUrl},on:{"load":_vm.onImageLoaded}}),(!_vm.imageReady)?[_vm._v("\n        "+_vm._s(_vm.initials)+"\n    ")]:_vm._e(),(_vm.shouldShowIcon)?_c('div',{class:{
            'vrm-avatar__icon vrm-avatar__icon--blue': _vm.hasFullControl,
            'vrm-avatar__icon vrm-avatar__icon--green': _vm.isTechnician,
        }},[_c('span',{class:{
                'sg-vrm-icon_148_star_border_12px': _vm.hasFullControl,
                'sg-vrm-icon_124_wrench-16px': _vm.isTechnician,
            }})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }